import { useRoleCheck } from "./use-role-check";

/**
 * @deprecated Use useRoleCheck() instead for enhanced RBAC support
 * This hook is kept for backward compatibility
 */
export function useAdminCheck() {
  const { data: roleData, isLoading } = useRoleCheck();
  
  return {
    data: {
      isAdmin: roleData?.isAdmin || false,
      isLoading
    },
    isLoading
  };
}
